import type { QueryClient } from '@tanstack/react-query';

import { queryKeys } from './queryKeys';

export const invalidateCarsQueries = async (queryClient: QueryClient) => {
  await queryClient.invalidateQueries({ queryKey: queryKeys.cars.all });
};
